import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import DeviceStorage from '../../../components/DeviceStorage/DeviceStorage';
import Device from "../../../devices/device";
import store from "src/store";
import Utils from "src/utils/Utils";
import {DISABLE_MODAL_RETRIES} from '../../RequestManagerConstants';
import settings from "../../../devices/all/settings";
class IsLoggedIn extends AbstractRequestTask {

  constructor(includpaywayprofile = false, version = 'v1') {
    super();
    this._includpaywayprofile = includpaywayprofile
    this.version = version;
  }

  getHeaders() {
    return {};
  }

  isPTV() {
    const state = store.getState();
    const { user }  = state;
    return Utils.isPTV(user);
  }
  
  getParams() {
    const params = super.getParams();
    const includpaywayprofile = this._includpaywayprofile;
    const user_id = DeviceStorage.getItem('user_id') || '';
    delete params.api_version;

    const extra_params = {includpaywayprofile, user_id}

    if (this.isPTV()) {
      const {serial_id} = Device.getDevice().getConfig();
      extra_params.serial_id = serial_id;
    }
    
    return {...params, ...extra_params};
  }
  
  getShowErrorModal(){
    return DISABLE_MODAL_RETRIES;
  }

  getUrl() {
    if(settings.fake_url_mockoon) {
      return `${settings.fake_url_mockoon}/services/user/isloggedin`;
    }
    else {
      const protocol = 'http';
      const server = settings.use_mock_endpoint ? settings.mock.server : Launcher.get("akamai_mfwk");
      const endpoint = settings.use_mock_endpoint ? 'ClaroVideo/Isloggedin/1.0.0/user' : 'services/user'
      const version = this.version
      const apiname = 'isloggedin';
      return `${protocol}://${server}/${endpoint}/${version}/${apiname}`;
    }
  }

  isValid(data){
    if (!data.response || data.response.is_user_logged_in === undefined) {
      return false;
    }
    return true;
  }

  success(data, b) {
    this.resolve(data);
  }
}

export default IsLoggedIn;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/IsLoggedInTask.js